// extracted by mini-css-extract-plugin
module.exports = {"rotation":"CertificazioniHubTemplate_rotation__sgjwK"};